import { render, staticRenderFns } from "./AddEditClass.vue?vue&type=template&id=2640e330&"
import script from "./AddEditClass.vue?vue&type=script&lang=js&"
export * from "./AddEditClass.vue?vue&type=script&lang=js&"
import style0 from "./AddEditClass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports